import React from 'react'

export const UploadFileIcon = props => {
  return (
    <svg
      width="32"
      height="24"
      viewBox="0 0 32 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M25.8 9.06C24.8933 3.885 20.8533 0 16 0C12.1467 0 8.8 2.46 7.13333 6.06C3.12 6.54 0 10.365 0 15C0 19.965 3.58667 24 8 24H25.3333C29.0133 24 32 20.64 32 16.5C32 12.54 29.2667 9.33 25.8 9.06ZM18.6667 13.5V19.5H13.3333V13.5H9.33333L16 6L22.6667 13.5H18.6667Z"
        fill="#0B2456"
      />
    </svg>
  )
}
